import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { api } from "../lib/api";

const mmss = (ms) => `${String(Math.floor(ms / 6e4)).padStart(2, "0")}:${String(Math.floor((ms % 6e4) / 1e3)).padStart(2, "0")}`;

export function SeatHold({ orderId, onExpire }) {
  const [h, setH] = useState(null); const [now, setNow] = useState(Date.now());
  useEffect(() => { api.get(`/giglife/holds/${orderId}`).then((r) => setH(r.data)).catch(() => setH(false)); }, [orderId]);
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const left = h ? new Date(h.expires_at) - now : 1; const expired = !h || !h.active || left <= 0;
  useEffect(() => { if (h && h.active && expired) onExpire?.(); /* eslint-disable-next-line */ }, [expired]);
  if (!h || h.status === "paid") return null;
  const what = h.seats.length ? `Seat${h.seats.length > 1 ? "s" : ""} ${h.seats.join(", ")}` : `${h.tickets} × ${h.tier_name || "ticket"}`;
  return (
    <div className={`rounded-sm border p-4 text-sm flex flex-wrap items-center gap-3 ${expired ? "border-stone-700 bg-stone-900/40" : "border-amber-400/50 bg-amber-400/10"}`} data-testid="giglife-seat-hold">
      <Timer className={`w-5 h-5 ${expired ? "text-stone-500" : "text-amber-400 animate-pulse"}`} />
      <div className="flex-1 min-w-[200px]">
        {expired ? <p className="font-semibold text-stone-300" data-testid="giglife-hold-expired">Your hold on {what} has been released</p> : <p className="font-semibold text-amber-200">{what} held for you</p>}
        <p className="text-xs text-stone-400">{expired ? "Pick your seats again to start a fresh 30-minute hold." : "Finish checkout before the timer runs out or the seats go back on sale."}</p>
      </div>
      {!expired && <p className="font-mono text-2xl font-black tabular-nums text-amber-400" data-testid="giglife-hold-timer">{mmss(left)}</p>}
      {!expired && h.resume_url && <a href={h.resume_url} className="h-10 px-4 inline-flex items-center rounded-sm bg-amber-400 text-black font-bold text-xs hover:bg-amber-300" data-testid="giglife-hold-resume">RESUME CHECKOUT</a>}
    </div>
  );
}
